// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import Vue from 'vue'
// import YDUI from 'vue-ydui'

import App from './App'
import router from './router'
import {fetch, post, remove, put} from "@common/HttpRequest"
// import VueVideoPlayer from 'vue-video-player'

// import 'vue-ydui/dist/ydui.rem.css'
import '@/assets/css/main.css'
import '@/assets/icon/iconfont.css'

import VueI18n from 'vue-i18n'

const i18n = new VueI18n({
  locale: 'zh', // 语言标识
  messages: {
    'zh': require('./assets/lang/zh'),
    'en': require('./assets/lang/en')
  }
})


Vue.config.productionTip = false

// Vue.use(ydui)
Vue.use(VueVideoPlayer, {})

Vue.prototype.$fetch = fetch
Vue.prototype.$post = post
Vue.prototype.$remove = remove
Vue.prototype.$put = put

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js